import { useContext } from "react";

import type { TenantThemeRuntime } from "../core/types.ts";
import { TenantThemeRuntimeContext } from "./context.ts";

export function useTenantThemeRuntime(): TenantThemeRuntime {
  const runtime = useContext(TenantThemeRuntimeContext);

  if (!runtime) {
    throw new Error("useTenantThemeRuntime must be used within TenantThemeProvider");
  }

  return runtime;
}
